module.exports = __webpack_public_path__ + "media/images/pages/fcr/flashpeel-813f775f4c53a3fe2c109f1958039f68.png";